import { createFileRoute } from '@tanstack/react-router';

import { ApprovalsPage } from '@/features/approvals/components/approvals-page';

export const Route = createFileRoute('/_app/approvals/')({
  component: ApprovalsPage,
});
